export default __webpack_public_path__ + "static/media/message.415ee335.mp3";